var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.isAssistanceRequired)?[(_vm.isRoltek)?_c('Button',{staticClass:"u-b1",attrs:{"data-test":"offer-send-roltek-control","icon":"security-scan","type":"default"},on:{"click":_vm.onRequestControl}},[_vm._v(" "+_vm._s(_vm.$t('Finish Roltek control'))+" ")]):_vm._e()]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }